import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { NPageHeader } from '../page/header/page-header.interface';
@Component({
    selector: 'meganav-overlay',
    templateUrl: 'meganav-overlay.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ToggleModule, CommonModule]
})
export class MeganavOverlayComponent {
    readonly meganavToggleGroupId = NPageHeader.MEGANAV_GROUP_ID;
}
